import styled, { css } from 'styled-components';

export const PaymentFormElement = styled.form`
  width: 100%;
`;

export const PaymentFormContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 24px;
  gap: 24px;
  width: 100%;
`;

export const OptionalPaymentDetailsContainer = styled.div`
  width: 100%;
`;

export const OptionalPaymentDetailsPanel = styled.div`
  width: 100%;
  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}
`;
